export default __webpack_public_path__ + "a3c381965d3809bf2525ec4173798d21.png";